module.exports = __webpack_public_path__ + "static/media/bar-chart.e0ecca93.svg";